import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 3.4a6.513 6.513 0 0 0-6.513 6.513c0 1.02.388 2.208 1.058 3.472.662 1.25 1.557 2.499 2.472 3.617A38.218 38.218 0 0 0 12 20.23a38.203 38.203 0 0 0 2.983-3.229c.915-1.118 1.81-2.366 2.472-3.617.67-1.264 1.058-2.452 1.058-3.472A6.513 6.513 0 0 0 12 3.4Zm0 18.2c-.664.748-.665.748-.665.747l-.002-.001-.005-.005-.018-.017-.068-.06-.248-.23a40.214 40.214 0 0 1-3.524-3.765c-.964-1.178-1.947-2.539-2.693-3.949-.74-1.396-1.29-2.921-1.29-4.407a8.513 8.513 0 0 1 17.026 0c0 1.486-.55 3.01-1.29 4.407-.746 1.41-1.73 2.771-2.692 3.948a40.202 40.202 0 0 1-3.773 3.995l-.068.061-.018.017-.005.005-.002.001L12 21.6Zm0 0 .664.748-.664.59-.665-.59L12 21.6Zm0-13.4a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8ZM8.6 9.6a3.4 3.4 0 1 1 6.8 0 3.4 3.4 0 0 1-6.8 0Z"
  />,
  'Marker2'
)
